import script from "./ModalImageView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModalImageView.vue?vue&type=script&setup=true&lang=ts"

import "./ModalImageView.vue?vue&type=style&index=0&id=29d734d6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29d734d6"]])

export default __exports__